import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action } from '@ngrx/store';
import { TrainingEventActions, TrainingEventActionTypes } from './training-event.actions';
import { TrainingEventEntity } from './training-event.model';

export interface TrainingEventEntities extends EntityState<TrainingEventEntity> {
  // additional entities state properties
}

export const adapter: EntityAdapter<TrainingEventEntity> = createEntityAdapter<
  TrainingEventEntity
>();

export const initialState: TrainingEventEntities = adapter.getInitialState({
  // additional entity state properties
});

export function reducer(state = initialState, incomingAction: Action): TrainingEventEntities {
  const action = incomingAction as TrainingEventActions;
  switch (action.type) {
    case TrainingEventActionTypes.AddTrainingEvent: {
      return adapter.addOne(action.payload.trainingEvent, state);
    }

    case TrainingEventActionTypes.UpsertTrainingEvent: {
      return adapter.upsertOne(action.payload.trainingEvent, state);
    }

    case TrainingEventActionTypes.AddTrainingEvents: {
      return adapter.addMany(action.payload.trainingEvents, state);
    }

    case TrainingEventActionTypes.UpsertTrainingEvents: {
      return adapter.upsertMany(action.payload.trainingEvents, state);
    }

    case TrainingEventActionTypes.UpdateTrainingEvent: {
      return adapter.updateOne(action.payload.trainingEvent, state);
    }

    case TrainingEventActionTypes.UpdateTrainingEvents: {
      return adapter.updateMany(action.payload.trainingEvents, state);
    }

    case TrainingEventActionTypes.DeleteTrainingEvent: {
      return adapter.removeOne(action.payload.id, state);
    }

    case TrainingEventActionTypes.DeleteTrainingEvents: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case TrainingEventActionTypes.LoadTrainingEvents: {
      return adapter.setAll(action.payload.trainingEvents, state);
    }

    case TrainingEventActionTypes.ClearTrainingEvents: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
